import { Action } from "redux"

import * as actions from "./actions"
import { dictionary } from "./hardcodedDictionary"
import { IContextualHelp } from "./index"

export const initialState: IContextualHelp = {
    dictionaries: [dictionary],
    isTooltipsOverlayVisible: false,
    isDictionaryPopupVisible: false,
    tooltipsOverlay: {
        selectedTerm: null,
        supportMailAddress: "",
    },
    dictionaryPopup: {
        selectedTermCode: null,
        termsIsLoading: false,
        termsFilter: "",
        termsPagination: {
            size: 20,
            page: 1,
        },
    },
}

const ACTION_HANDLERS: {
    [action: string]: (state: IContextualHelp, props: Action) => IContextualHelp
} = {
    [actions.UPDATE_SUPPORT_MAIL_ADDRESS]: (
        state,
        { supportMailAddress }: actions.SupportMailAddress,
    ): IContextualHelp => ({
        ...state,
        tooltipsOverlay: {
            ...state.tooltipsOverlay,
            supportMailAddress,
        },
    }),

    [actions.INITIALIZE_DICTIONARY_VISIBLE]: (
        state,
        { termCode }: actions.TermCodeAction,
    ): IContextualHelp => ({
        ...state,
        isDictionaryPopupVisible: true,
        isTooltipsOverlayVisible: true,
        dictionaryPopup: {
            ...state.dictionaryPopup,
            selectedTermCode: termCode,
        },
    }),

    [actions.TRIGGER_TOOLTIP]: (
        state,
        { term }: actions.TermAction,
    ): IContextualHelp => ({
        ...state,
        isTooltipsOverlayVisible: true,
        tooltipsOverlay: {
            ...state.tooltipsOverlay,
            selectedTerm: term,
        },
    }),

    [actions.UPDATE_TOOLTIPS_OVERLAY_VISIBILITY]: (
        state,
        { isVisible }: actions.UpdateVisibility,
    ): IContextualHelp => {
        if (isVisible) {
            return {
                ...state,
                isTooltipsOverlayVisible: isVisible,
            }
        } else {
            return {
                ...state,
                isTooltipsOverlayVisible: isVisible,
                tooltipsOverlay: {
                    ...state.tooltipsOverlay,
                    selectedTerm: null,
                },
            }
        }
    },

    [actions.UPDATE_DICTIONARY_POPUP_VISIBILITY]: (
        state,
        { isVisible }: actions.UpdateVisibility,
    ): IContextualHelp => {
        if (isVisible) {
            return {
                ...state,
                isDictionaryPopupVisible: isVisible,
            }
        } else {
            return {
                ...state,
                isDictionaryPopupVisible: isVisible,
                dictionaryPopup: {
                    ...state.dictionaryPopup,
                    selectedTermCode: null,
                },
            }
        }
    },

    [actions.FILTER_TERMS]: (
        state,
        { filter }: actions.Filter,
    ): IContextualHelp => ({
        ...state,
        dictionaryPopup: {
            ...state.dictionaryPopup,
            termsFilter: filter,
            termsIsLoading: true,
            termsPagination: {
                ...state.dictionaryPopup.termsPagination,
                page: 1,
            },
        },
    }),

    [actions.LOAD_MORE_TERMS]: (state): IContextualHelp => ({
        ...state,
        dictionaryPopup: {
            ...state.dictionaryPopup,
            termsPagination: {
                ...state.dictionaryPopup.termsPagination,
                page: state.dictionaryPopup.termsPagination.page + 1,
            },
        },
    }),

    [actions.SET_DICTIONARY_LOADING]: (
        state,
        { isLoading }: actions.SetLoading,
    ): IContextualHelp => ({
        ...state,
        dictionaryPopup: {
            ...state.dictionaryPopup,
            termsIsLoading: isLoading,
        },
    }),

    [actions.SELECT_TERM_IN_DICTIONARY]: (
        state,
        { termCode }: actions.TermCodeAction,
    ): IContextualHelp => ({
        ...state,
        dictionaryPopup: {
            ...state.dictionaryPopup,
            selectedTermCode: termCode,
        },
    }),

    [actions.SELECT_TERM_IN_TOOLTIPS]: (
        state,
        { term }: actions.TermAction,
    ): IContextualHelp => ({
        ...state,
        tooltipsOverlay: {
            ...state.tooltipsOverlay,
            selectedTerm: term,
        },
    }),
}

export default function reducer(
    state: IContextualHelp = initialState,
    action: Action,
): IContextualHelp {
    const handler: (state: IContextualHelp, action: Action) => IContextualHelp =
        ACTION_HANDLERS[action.type]
    return handler ? handler(state, action) : state
}
